// extracted by mini-css-extract-plugin
module.exports = {"backGround":"AuthOTP_SA_backGround__ZmEvG","height":"AuthOTP_SA_height__3fjCA"};